import { BusinessEntity } from '../models/business-entity';
import { File } from '../models/file';
import { plainToInstance } from 'class-transformer';

export interface GetUserBusinessEntitiesOpts {
  order_by?: string;
  page?: number;
  skip_files?: boolean;
}

export class BusinessEntityListItem extends BusinessEntity {
  isOpened = false;
  currentFilesPage = 1;

  toFileSet(rawFileData: File[]) {
    this.file_set = rawFileData.map((fileData) => {
      const file = plainToInstance(File, fileData);
      file.setListingState();

      return file;
    });
  }
}

export interface BusinessEntityListResult {
  count: number;
  results: BusinessEntityListItem[];
}
